import React from 'react';
import PropTypes from 'prop-types';
import EmptyState from '../../../../components/EmptyState/EmptyState';
import {
  Section,
  SectionTitle,
  MarketingText,
  BenefitsGrid,
  BenefitsColumn,
  BenefitsList,
  BenefitItem,
  SubTitle,
} from './TyreMarketing.style';

const TyreMarketing = ({
  marketingText,
  introText,
  customerBenefits,
  businessPartnerBenefits,
  t,
}) => {
  const hasContent =
    marketingText ||
    introText ||
    customerBenefits?.length > 0 ||
    businessPartnerBenefits?.length > 0;

  if (!hasContent) {
    return (
      <Section>
        <SectionTitle>Marketing</SectionTitle>
        <EmptyState
          icon="mdi-text-box-outline"
          title="Ni marketinških informacij"
          description="Marketinške podrobnosti za ta izdelek niso na voljo"
        />
      </Section>
    );
  }

  const hasBenefits =
    customerBenefits?.length > 0 || businessPartnerBenefits?.length > 0;

  const hasCustomerBenefits = customerBenefits && customerBenefits.length > 0;
  const hasBusinessBenefits = businessPartnerBenefits && businessPartnerBenefits.length > 0;
  const singleColumn = (hasCustomerBenefits && !hasBusinessBenefits) || (!hasCustomerBenefits && hasBusinessBenefits);

  return (
    <Section>
      <SectionTitle>Marketing</SectionTitle>

      {introText && <MarketingText>{introText}</MarketingText>}
      {marketingText && <MarketingText>{marketingText}</MarketingText>}

      {hasBenefits && (
        <BenefitsGrid singleColumn={singleColumn}>
          {customerBenefits && customerBenefits.length > 0 && (
            <BenefitsColumn>
              <SubTitle>Koristi za stranke</SubTitle>
              <BenefitsList>
                {customerBenefits.map(
                  (benefit, index) =>
                    benefit && (
                      <BenefitItem key={index} index={index}>
                        <i className="mdi mdi-check-circle" />
                        {benefit}
                      </BenefitItem>
                    )
                )}
              </BenefitsList>
            </BenefitsColumn>
          )}

          {businessPartnerBenefits && businessPartnerBenefits.length > 0 && (
            <BenefitsColumn>
              <SubTitle>Koristi za poslovne partnerje</SubTitle>
              <BenefitsList>
                {businessPartnerBenefits.map(
                  (benefit, index) =>
                    benefit && (
                      <BenefitItem key={index} index={index}>
                        <i className="mdi mdi-check-circle" />
                        {benefit}
                      </BenefitItem>
                    )
                )}
              </BenefitsList>
            </BenefitsColumn>
          )}
        </BenefitsGrid>
      )}
    </Section>
  );
};

TyreMarketing.propTypes = {
  marketingText: PropTypes.string,
  introText: PropTypes.string,
  customerBenefits: PropTypes.array,
  businessPartnerBenefits: PropTypes.array,
};

export default TyreMarketing;
